import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

type PSPSEventIconProps = {
  size?: number;
  color?: string;
  variant?: 'filled' | 'outlined';
  className?: string;
} & Omit<SvgIconProps, 'color'>;

const PSPSEventIcon: React.FC<PSPSEventIconProps> = ({
  size = 32,
  color = '#9747FF',
  variant = 'filled',
  className,
  ...rest
}) => {
  return (
    <SvgIcon
      className={className}
      style={{ fontSize: size, color }}
      viewBox="0 0 26 32"
      {...rest}
    >
      {variant === 'outlined' ? (
        <path
          d="M13 21.7409C13.3556 21.7409 13.6482 21.6243 13.8779 21.3909C14.1074 21.1579 14.2221 20.8671 14.2221 20.5184C14.2221 20.1629 14.1074 19.8686 13.8779 19.6355C13.6482 19.4022 13.3556 19.2855 13 19.2855C12.6444 19.2855 12.3518 19.4022 12.1221 19.6355C11.8926 19.8686 11.7779 20.1629 11.7779 20.5184C11.7779 20.8671 11.8926 21.1579 12.1221 21.3909C12.3518 21.6243 12.6444 21.7409 13 21.7409ZM11.9529 16.5976H14.0471V8.40094H11.9529V16.5976ZM13 31.7814C9.38389 30.7914 6.39653 28.647 4.03792 25.3484C1.67931 22.0501 0.5 18.3861 0.5 14.3564V4.89052L13 0.210938L25.5 4.89052V14.3564C25.5 18.3861 24.3207 22.0501 21.9621 25.3484C19.6035 28.647 16.6161 30.7914 13 31.7814ZM13 29.5868C16.0356 28.6062 18.5288 26.6968 20.4796 23.8584C22.4304 21.0201 23.4058 17.8527 23.4058 14.3564V6.3401L13 2.43719L2.59417 6.3401V14.3564C2.59417 17.8527 3.56958 21.0201 5.52042 23.8584C7.47125 26.6968 9.96444 28.6062 13 29.5868Z"
          fill="currentColor"
        />
      ) : (
        <path
          d="M13 21.7409C13.3556 21.7409 13.6482 21.6243 13.8779 21.3909C14.1074 21.1579 14.2221 20.8671 14.2221 20.5184C14.2221 20.1629 14.1074 19.8686 13.8779 19.6355C13.6482 19.4022 13.3556 19.2855 13 19.2855C12.6444 19.2855 12.3518 19.4022 12.1221 19.6355C11.8926 19.8686 11.7779 20.1629 11.7779 20.5184C11.7779 20.8671 11.8926 21.1579 12.1221 21.3909C12.3518 21.6243 12.6444 21.7409 13 21.7409ZM11.9529 16.5976H14.0471V8.40094H11.9529V16.5976ZM13 31.7814C9.38389 30.7914 6.39653 28.647 4.03792 25.3484C1.67931 22.0501 0.5 18.3861 0.5 14.3564V4.89052L13 0.210938L25.5 4.89052V14.3564C25.5 18.3861 24.3207 22.0501 21.9621 25.3484C19.6035 28.647 16.6161 30.7914 13 31.7814Z"
          fill="currentColor"
        />
      )}
    </SvgIcon>
  );
};

export default PSPSEventIcon;
